module.exports = __webpack_public_path__ + "img/tree-09-e-leaves.5590ea30.png";